export const IMAGES = {
  MAX_SELL_UPLOADED_COUNT: 10,
};
